module.exports = "<div *ngIf=\"barraGoverno\" class=\"gov-br\" [style.background-color]=\"barraGoverno.cor\">\n  <div class=\"flex-between wrapper\">\n    <div class=\"logotipo\" [style.background-image]=\"'url(' + barraGoverno.imagem.url + ')'\"></div>\n    <ul>\n      <li *ngFor=\"let link of barraGoverno.links\">\n        <a [href]=\"link.link\"\n           [style.color]=\"link.corTexto\"\n           target=\"_blank\">\n          {{link.nome}}\n        </a>\n      </li>\n    </ul>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/barra-governo/barra-governo.component.html
// module id = ./src/app/components/barra-governo/barra-governo.component.html
// module chunks = main